import View from './view.js'
import React, { useMemo } from 'react'
import { DataProvider } from 'Simple/Data.js'
import format from 'date-fns/format'
import { useDataValue } from 'Simple/Data'

export default function Logic(props) {
  let auth = useDataValue({
    viewPath: props.viewPath,
    context: 'auth',
    path: 'access_token_data',
  })

  let value = useMemo(() => {
    let date_now = new Date()
    date_now.setSeconds(0)
    let date = format(date_now, 'yyyy-MM-dd')
    let time = format(date_now, 'HH:mm:ss')

    let value = {
      selected_name: null,
      selected_id: [],
      selected_vaxiom_user_id: null,
      date,
      time,
      is_user_clocked_in: null,
      selected_email: null,
      password: null,
      access_token: null,
      role: null,
      comment: '',
      state: 'NORMAL',
    }

    if (auth) {
      value.selected_id = [auth.user_id]
      value.selected_vaxiom_user_id = auth.vaxiom_user_id
    }

    return value
  }, [auth])

  return (
    <DataProvider context="clockin" value={value} viewPath={props.viewPath}>
      <View viewPath={props.viewPath} />
    </DataProvider>
  )
}

// TODO: move to data.json + useDataTransform
